export default "__VITE_ASSET__CcC5Ud5R__"